import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Card } from "react-bootstrap";
import NumberFormat from 'react-number-format';
import { Button } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import SvgIcon from '@material-ui/core/SvgIcon';
import CheckCircleIcon from '../../../../icons/check-circle.svg';
import { alpha } from '@material-ui/core/styles'

import './QuoteCard.scss';

const grey = '#cdcdcd';
const useStyles = makeStyles(theme => ({
    active: {
        border: `2px solid ${theme.palette.primary.main}`,
        backgroundColor: alpha(theme.palette.primary.main, .05),
    },
    activeIcon: {
        color: theme.palette.primary.main,
    },
    greyOut: {
        color: `${grey}!important`,
    },
    notDisabled: {
        '&:hover': {
            cursor: 'pointer'
        },
    }

}));
export default function QuoteCard(props) {
    const classes = useStyles();

    return (
        <Card onClick={() => {
            if (!props.disabled) props.flipActive();
        }
        }
            className={`aflac-quote-card p-3 shadow-sm ${props.active ? classes.active : ''} ${props.disabled ? classes.greyOut : classes.notDisabled}`}
        >
            <Col>
                <Row>
                    <Col className="p-0">
                        <img src={props.iconUrl} className="mb-2" alt="" />
                    </Col>
                    <Col xs="auto" className="p-0" >
                        <SvgIcon component={CheckCircleIcon} className={props.active ? classes.activeIcon : classes.greyOut} />
                    </Col>
                </Row>
                <Row>
                    <h3 className={props.disabled ? classes.greyOut : ''}>{props.title}</h3>
                </Row>
                <Row>
                    {!props.loading && props.monthlyRate ? <span><NumberFormat
                        className="quote-amount-dollars"
                        value={props.monthlyRate}
                        displayType={'text'}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                    />
                        <span className="quote-amount-mo"> /mo</span>
                    </span>
                        :
                        <span className="dots">...</span>}
                </Row>
                <Row>
                    <Button variant="text" color="primary" onClick={props.productDetailsOnClick} disabled={props.disabled}>PRODUCT DETAILS</Button>
                </Row>
                <Row><p>{props.disclaimers}</p></Row>
            </Col>
        </Card>
    )
}

QuoteCard.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string.isRequired,
        PropTypes.object.isRequired,
    ]),
    iconUrl: PropTypes.string.isRequired,
    monthlyRate: PropTypes.number,
    productDetailsOnClick: PropTypes.func.isRequired,
    active: PropTypes.bool,
    flipActive: PropTypes.func.isRequired,
    disclaimers: PropTypes.string,
    disabled: PropTypes.bool,
    loading: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Quoters/Supplemental/Helpers/QuoteCard.js